import { render } from "./ViewMapByCoordinates.vue?vue&type=template&id=b5a2b5f0&scoped=true"
import script from "./ViewMapByCoordinates.vue?vue&type=script&lang=js"
export * from "./ViewMapByCoordinates.vue?vue&type=script&lang=js"

import "./ViewMapByCoordinates.vue?vue&type=style&index=0&id=b5a2b5f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a2b5f0"]])

export default __exports__